import styled from 'styled-components'

export default styled.div`
  max-width: 364px;
  width: auto;
  height: auto;
  max-height: auto;
  background-color: #EBFFF3;
  border-radius: 10px;
  overflow: hidden;
  z-index: 100;
  position: absolute;
  top: 90px;
  right: 10px;
  flex-direction: row;
  animation-name: appear, hide;
  animation-duration: 0.2s, 0.2s;
  animation-timing-function: ease-in-out, ease-in-out;
  animation-iteration-count: 1, 1;
  margin-left: 10px;
  shadow-color: #000;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.25;
  shadow-radius: 3.84px;
  elevation: 5;

  > span {
    display: inline-block;
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-weight: 700;
    flex: 1;
    width: 100%;
    margin: 24px 0 0 24px;
    font-size: 16px;
  }

  > p {
    display: inline-block;
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-weight: 400;
    flex: 1;
    width: 86%;
    margin: 8px 0 0 24px;
    font-size: 14px;
  }

  > a {
    display: inline-block;
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-weight: 600;
    color: #04623A;
    flex: 1;
    width: 100%;
    align-items: center;
    justify-content: center;
    margin: 24px 0 10px 20px;
    font-size: 16px;
    text-decoration: underline;
  }

  > img {
    margin: 24px 24px 0 0;
    filter: invert(0%) sepia(0%) grayscale(0%) brightness(0%);
    cursor: pointer;
  }

  &.error {
    background-color: #FFE5E5;
    span {
      color: #232530;
    }
    a {
      color: #232530;
    }
  }

  // TODO: Notification animation
  /* @keyframes appear {
    10% {
      max-height: 65px;
    }
  }
  @keyframes hide {
    100% {
      max-height: 0;
    }
  } */
`

export const ContainerDiv = styled.div`
  margin: 24px 24px 24px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > span {
   width: 160px;
  }
`

export const Button = styled.button`
  border-width: 0px;
  background-color: #DD2F4E;
  border-radius: 10px;
  padding: 10px;
  color: #fff;
  font-size: 14px;
  font-family: ${ ({ theme }) => theme.fontFamily };
`

